export interface RemoteConfigState {
  [key: string]: string | boolean | number | object
  interval: number
  maintenance: boolean
  maintenanceParams: MaintenanceParams
  version: string
  versionIsIgnored: boolean
  atomicEnabled: boolean
  seedEnabled: boolean
  traderSpecialsEnabled: boolean
}

export interface MaintenanceParams {
  heading: string
  message: string
}

export enum ErrorCode {
  ServiceUnavailable = 'urn:errors:service-unavailable',
}

export type ServiceUnavailableResponse = {
  type: 'urn:errors:service-unavailable'
  status: 503
  detail: 'In maintenance'
}
